<template>
  <div
    :class="[
      $style['jumbotron'],
      $style['rounded-top'],
      $style['text-white'],
      $style['pt-2']
    ]"
    style="border-radius:40px; background-color:#473e97; border-top-right-radius: .0rem !important; border-top-left-radius: .0rem !important"
  >
    <div
      :class="[
        $style['row'],
        $style['justify-content-between'],
        $style['mb-3']
      ]"
    >
      <div :class="[$style['col-4'], $style['text-left']]">
        <i class="fa fa-align-left"></i>
      </div>
      <div :class="[$style['col-4'], $style['text-right']]">
        <i class="fas fa-bell"></i>
      </div>
    </div>
    <div :class="[$style['row'], $style['justify-content-between']]">
      <div
        :class="[
          $style['col-4'],
          $style['text-left'],
          $style['font-weight-bold']
        ]"
      >
        <h5>Covid-19</h5>
      </div>
      <div :class="[$style['col-4'], $style['text-right']]">
        <!-- Example single danger button -->
        <div :class="[$style['btn-group']]">
          <button
            type="button"
            :class="[
              $style['btn'],
              $style['btn-sm'],
              $style['btn-danger'],
              $style['dropdown-toggle'],
              $style['btn-round-xs'],
              $style['btn-xs'],
              $style['pt-1'],
              $style['pb-1'],
              $style['bg-white'],
              $style['border-white']
            ]"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style="border-radius: 30px;padding-left: 10px;padding-right: 10px; color:black"
          >
            <img
              src="../../public/country/my.png"
              :class="[$style['rounded-circle'], $style['w-25']]"
            />
            MY
          </button>
          <div
            :class="[$style['dropdown-menu']]"
            style="min-width: 0rem; max-width: 118px; left: -4px;"
          >
            <a :class="[$style['dropdown-item']]" href="#">
              <img
                src="../../public/country/idn.png"
                :class="[$style['rounded-circle'], $style['w-25']]"
              />
              IDN</a
            >
            <a :class="[$style['dropdown-item']]" href="#">
              <img
                src="../../public/country/rus.png"
                :class="[$style['rounded-circle'], $style['w-25']]"
              />
              RUS</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      :class="[$style['row'], $style['mt-3'], $style['ml-1'], $style['mr-1']]"
    >
      <h6>Data nama dan NIK ini diambil dari API</h6>
    </div>
    <div
      :class="[$style['row'], $style['mt-2'], $style['ml-1'], $style['mr-1']]"
      style="color:#8885aa"
    >
       Nama saya {{data?.user[0]?.name ?? ''}} saya memiliki NIK : {{data?.user[0]?.nik  ?? ''}}
    </div>
    <div
      :class="[
        $style['row'],
        $style['mt-4'],
        $style['ml-1'],
        $style['mr-1'],
        $style['justify-content-between']
      ]"
    >
      <button
        :class="[$style['btn'], $style['btn-danger']]"
        style="border-radius: 20px"
      >
        <i class="fa fa-phone"></i>&nbsp; Call Now
      </button>
      <button
        :class="[$style['btn'], $style['btn-primary']]"
        style="border-radius: 20px"
      >
        <i class="fas fa-sms"></i>&nbsp; Send SMS
      </button>
    </div>
  </div>
  <div
    :class="[$style['row'], $style['ml-3'], $style['font-weight-bold']]"
    style="max-width: 300px;"
  >
    <h4>Prevention</h4>
  </div>
  <div
    :class="[
      $style['row'],
      $style['mt-0'],
      $style['ml-2'],
      $style['mr-2'],
      $style['justify-content-between']
    ]"
  >
    <div :class="[$style['col-4'], $style['text-center']]">
      <div>
        <img
          src="../../public/img/1.jpg"
          alt=""
          style="max-widht:90px; max-height:90px"
        />
      </div>
      <div :class="[$style['text-center']]">
        Avoid close contact
      </div>
    </div>
    <div :class="[$style['col-4'], $style['text-center']]">
      <div>
        <img
          src="../../public/img/2.jpg"
          alt=""
          style="max-widht:90px; max-height:90px"
        />
      </div>
      <div :class="[$style['text-center']]">
        Clean your hand
      </div>
    </div>
    <div :class="[$style['col-4'], $style['text-center']]">
      <div>
        <img
          src="../../public/img/3.jpg"
          alt=""
          style="max-widht:90px; max-height:90px"
        />
      </div>
      <div :class="[$style['text-center']]">
        Wear a facemask
      </div>
    </div>
  </div>
  <div
    :class="[$style['row'], $style['m-3'], $style['text-white']]"
    style="background-image: linear-gradient(to right, #aa9de3, #55559d); border-radius:20px"
  >
    <div :class="[$style['col-3']]">
      <img
        src="../../public/img/4.png"
        alt=""
        style=" max-height:120px; max-width: 146px;"
      />
    </div>
    <div :class="[$style['col-9']]">
      <div :class="[$style['col'], $style['mt-2']]">
        Do your own test!
      </div>
      <div :class="[$style['col']]" style="color:#cac6f3">
        Follow the instructions to do your own test.
      </div>
    </div>
  </div>
  <!-- Bottom Nav Bar -->
  <footer
    :class="[$style['row'], $style['p-2'], $style['justify-content-between']]"
    style="position: fixed;
bottom: 0;
width: 100%;
height: 60px;
background-color: #fff;
border-top: 1px solid transparent;
margin-left:0px
"
  >
    <div>
      <button
        :class="[$style['btn'], $style['text-white']]"
        class="fas fa-home"
        style="font-weight: bold; background:#4a7bfe; border-radius: 20px"
      ></button>
    </div>
    <div>
      <button
        :class="[$style['btn'], $style['text-secondary']]"
        class="fas fa-chart-bar"
        style="font-weight: bold;"
      ></button>
    </div>
    <div>
      <button
        :class="[$style['btn'], $style['text-secondary']]"
        class="fa fa-file-alt"
        style="font-weight: bold;"
      ></button>
    </div>
    <div>
      <button
        :class="[$style['btn'], $style['text-secondary']]"
        class="fas fa-info-circle"
        style="font-weight: bold;"
      ></button>
    </div>
  </footer>
</template>

<script>
import { reactive, onMounted } from "vue";

const axios = require("axios");
// @ is an alias to /src
const NodeRSA = require("node-rsa");
const key = new NodeRSA();
var CryptoJS = require("crypto-js");

// Decrypt
const bytes = CryptoJS.AES.decrypt(
  process.env.VUE_APP_ENCRYPTED_KEY,
  process.env.VUE_APP_SECRET
);
const hasil = bytes.toString(CryptoJS.enc.Utf8);

key.importKey(hasil, "pkcs1-pem");

export default {
  setup() {
    let data = reactive({ user: "" });
    async function loadData() {
      await axios
        .get(`${process.env.VUE_APP_API_URL || "https://pesan-rahasia.herokuapp.com" }/api/v2/user`)
        .then(function(response) {
          // handle success
          data.user = JSON.parse(key.decrypt(response.data, "utf-8"));
        })
        .catch(function(error) {
          // handle error
          console.log(error);
        })
        .then(function() {
          // always executed
        });
    }
    onMounted(() => {
      loadData();
      // console.log(process.env.VUE_APP_SECRET)
    });
    return {
      data
    };
  }
};
</script>
<style src="../assets/bootstrap.css" module />
